import { EditorState } from "draft-js";
import { Field, FieldInputProps, FieldMetaProps, FormikProps } from "formik";

import { makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import { useSubaccount } from "src/components/SubaccountProvider";
import { CampaignWithCalleeFields_calleeFields } from "src/graphql/generated/CampaignWithCalleeFields";
import { getCampaign_campaign } from "src/graphql/generated/getCampaign";
import formatPhoneNumber from "src/util/formatPhoneNumber";

import TextEditor from "./TextEditor";

const useStyles = makeStyles(theme => ({
  information: {
    marginBottom: theme.spacing(2)
  }
}));

export default function SendMessageSettings({
  campaign,
  textFieldName,
  onCreateCalleeField
}: {
  campaign: getCampaign_campaign;
  textFieldName: string;
  onCreateCalleeField: (
    name: string
  ) => Promise<CampaignWithCalleeFields_calleeFields>;
}): JSX.Element {
  const classes = useStyles();
  const { subaccount } = useSubaccount()!;

  return (
    <>
      <Alert severity="info" className={classes.information}>
        Callers will be prompted to confirm the contact's phone number and send
        them this message. They will not be able to edit the message text. The
        message will be sent from{" "}
        {formatPhoneNumber(subaccount.messagingPhoneNumber!)}.
      </Alert>
      <Field name={textFieldName}>
        {({
          field,
          form,
          meta
        }: {
          field: FieldInputProps<EditorState>;
          form: FormikProps<any>;
          meta: FieldMetaProps<EditorState>;
        }) => (
          <TextEditor
            label="Message"
            placeholder="Write a message to send to the contact"
            editorState={field.value}
            onChangeEditorState={newState =>
              form.setFieldValue(field.name, newState)
            }
            calleeFields={campaign.calleeFields}
            canUpdateCalleeFields={campaign.status === "DRAFT"}
            onCreateCalleeField={onCreateCalleeField}
            enableRichText={false}
            error={meta.touched && Boolean(meta.error)}
          />
        )}
      </Field>
    </>
  );
}
